/**
 * @desc 获取合规通道报名结果
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** merchantNo */
  merchantNo: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/merchant/complianceJoinResult',
    params,
    method: 'get',
  })
}
